<template>
	<AsiCardDetail :icon="icons.externalSource" :title="$t('globalConfig.terms.externalSource')"
	               :show-action-button="!readonly" @actionButtonClicked="updateDialog.open()">
		<AsiCardDetailEntry :label="$t('globalConfig.privateCustomerExternalId')"
		                    :icon="icons.externalSource"
		                    :value="globalConfig.privateCustomerExternalId"/>

		<GlobalConfigUpdateDialogExternalSource v-if="!readonly && updateDialog.isLoaded" :open="updateDialog.isOpen"
		                                        :global-config="globalConfig"
		                                        @cancel="updateDialog.close()" @save="updateDialog.close(); change();"/>
	</AsiCardDetail>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Emit, Prop} from 'vue-property-decorator';
	import Icon from "@/plugins/icons";
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
	import {IGlobalConfigAdmin} from "@/models/global-config/GlobalConfigAdminModels";
	import DialogHandler from "@/components/common/DialogHandler";
	import GlobalConfigUpdateDialogExternalSource
		from "@/components/global-config/admin/GlobalConfigUpdateDialogExternalSource.vue";

	@Component({
		components: {GlobalConfigUpdateDialogExternalSource, AsiCardDetailEntry, AsiCardDetail}
	})
	export default class GlobalConfigCardPrivateCustomerExternalId extends Vue {

		@Prop({type: Object, required: true})
		public globalConfig!: IGlobalConfigAdmin;

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		private icons = Icon;
		private updateDialog: DialogHandler = new DialogHandler();

		@Emit('change')
		public change(): void {
			return;
		}

	}
</script>

<style lang="scss" scoped>

</style>
